import type { AppApi } from '@wix/wix-data-client-common'
import type { ComponentRef, PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'
import type { MultiReferenceField } from './bindCategoryDatasets'

// TODO: implement duplicating repeater sections for collections with multiple
// multi-reference fields — current approach needs rethinking
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const duplicateRepeaterSections = async (_: {
  appApi: AppApi
  editorSdkProxy: EditorSDK
  pageRef: PageRef
  regularDatasetRef: ComponentRef
  additionalCategoryConsumerFields: MultiReferenceField[]
  additionalReferencedSchemas: Schema[]
}) => {}
